module.exports = __webpack_public_path__ + "img/leading-icon.451fca51.svg";